import { NonprofitAdminRequestDisplayModel } from '@core/models/claim.model';
import { MyNonprofitRow } from '@core/models/npo.model';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';


@RegisterYCState()
export class MyNonprofitsState extends BaseYcState {
  readonly requestsForUser: NonprofitAdminRequestDisplayModel[];
  readonly tableRows: MyNonprofitRow[];
  readonly useParentDescription: boolean;
  readonly useChapterDescription: boolean;
}
